import type {ViewStyle} from 'react-native';
// eslint-disable-next-line no-restricted-imports
import positioning from '@styles/utils/positioning';

const tooltipPlatformStyle: ViewStyle = positioning.pFixed;

export default tooltipPlatformStyle;
